import clsx from 'clsx';
import { useState } from 'react';
import { toAbsoluteUrl } from '../../../_metronic/helpers';
import { DefaultTitle } from '../../../_metronic/layout/components/header/page-title/DefaultTitle';
import { HeaderUserMenu } from '../../../_metronic/partials';
import { useGetUser} from '../../Hooks/CustomHooks';
import { useLayout } from '../../../_metronic/layout/core';
import NotificationManager from '../Notifications/NotificationManager';
import { Loading } from '../../Components/Loading/Loading';


function Toolbar() {

    const { classes } = useLayout();
    let user = useGetUser();

    const [totalNotificaciones, setTotalNotificaciones] = useState(0);
    const [isLoading, setIsLoading] = useState(true);


    return (
        <div className='toolbar' id='kt_toolbar'>
            <div
                id='kt_toolbar_container'
                className={clsx(classes.toolbarContainer.join(' '), 'py-6 d-flex flex-stack')}
            >
                <DefaultTitle />

                {isLoading && <Loading />}
                <div className='d-flex align-items-center py-3'>

                    <div className='d-flex align-items-center ms-1 ms-lg-3'>
                        <div
                            className='btn btn-icon btn-icon-muted btn-active-light btn-active-color-primary w-30px h-30px w-md-40px h-md-40px'
                            data-kt-menu-trigger='click'
                            data-kt-menu-attach='parent'
                            data-kt-menu-placement='bottom-end'
                            
                        >
                            <span className='svg-icon svg-icon-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-bell" viewBox="0 0 16 16">
                                    <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z"></path>
                                </svg>
                                <span className="badge badge-primary badge-circle badge-sm"> {totalNotificaciones} </span>
                         
                            </span>
                        </div>

                        
                        <NotificationManager user={user} setTotalNotificaciones={setTotalNotificaciones} setIsLoading={setIsLoading}></NotificationManager>

                    </div>



                    <div className={clsx('d-flex align-items-center', 'ms-1 ms-lg-3')} id='kt_header_user_menu_toggle'>
                        <div
                            className={clsx('cursor-pointer symbol', 'symbol-30px symbol-md-30px')}
                            data-kt-menu-trigger='click'
                            data-kt-menu-attach='parent'
                            data-kt-menu-placement='bottom-end'
                            data-kt-menu-flip='bottom'
                        >
                            {/* <img src={toAbsoluteUrl('/media/avatars/150-2.jpg')} alt='metronic' /> */}
                            {/* <i class="fi fi-rr-user fs-1"></i> */}
                            <i className="fi fi-rr-user fs-1"></i>
                        </div>
                        <HeaderUserMenu user={user} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Toolbar
